import classNames from 'classnames';
import ReactMarkdown from 'react-markdown';
import { Button, Checkbox, TextField, Typography } from '@arionbanki/arionui';
import { useAuthenticate } from './useAuthenticate';
import imgPrimary from 'img/login_bg.svg';
import imgSecondary from 'img/gold.jpg';

export function Authenticate() {
	const { config, isManualSignCompany, flowType, formErrors, onSubmit, t, ...props } = useAuthenticate();
	return (
		<div className="row mt-5">
			<div className="col-12 col-md-6 col-lg-6 d-md-none mb-5">
				<Images />
			</div>
			<div className="col-12 col-md-6 col-lg-6">
				<Typography TagName="h3" className="mb-4">
					{t(`${flowType}_title`, 'authentication', true)}
				</Typography>
				<Typography TagName="p">{t(`${flowType}_main`, 'authentication', true)}</Typography>
				<form onSubmit={onSubmit} className="mb-4 auth">
					{config.IS_EMPLOYEE_WEB && (
						<TextField
							error={!!formErrors['kennitala']}
							label={t('kennitala')}
							message={formErrors['kennitala']}
							name="kennitala"
						/>
					)}
					<TextField
						error={!!formErrors['phone']}
						label={config.IS_EMPLOYEE_WEB ? t('phone') : t('phoneOrKennitala')}
						message={formErrors['phone']}
						name="phone"
					/>
					<TextField error={!!formErrors['email']} label={t('email')} message={formErrors['email']} name="email" />
					{config.IS_EMPLOYEE_WEB && (
						<>
							<div className={classNames('mt-4', { 'mb-4': !isManualSignCompany })}>
								<Checkbox
									checked={isManualSignCompany}
									label={t('is_company_kennitala')}
									name="isManualSignCompany"
									id="isManualSignCompany"
									onChange={() => props.setIsManualSignCompany(!isManualSignCompany)}
								/>
							</div>
							{isManualSignCompany && (
								<TextField
									error={!!formErrors['companyKennitala']}
									label={t('company_kennitala', 'general')}
									message={formErrors['companyKennitala']}
									name="companyKennitala"
								/>
							)}
						</>
					)}
					{props.SHOW_COSTS_FOR_FLOW_TYPES[`${flowType}`] && (
						<ReactMarkdown className="arionui text-small my-4">{t('portfolio_costs')}</ReactMarkdown>
					)}
					<Button className="mt-5" size="large" width="100%">
						{t('submit')}
					</Button>
				</form>
				<ReactMarkdown className="arionui text-small">
					{t('mv_authentication_privacy_policy', 'authentication')}
				</ReactMarkdown>
			</div>
			<div className="col-12 col-md-6 col-lg-6 d-none d-md-block">
				<Images />
			</div>
		</div>
	);
}

function Images() {
	return (
		<>
			<img alt="" className="w-100 primary" src={imgPrimary} />
			<div className="h-100 w-100 secondary auth-img-secondary">
				<img alt="" className="w-75" src={imgSecondary} />
			</div>
		</>
	);
}
